import React, { useState } from 'react';

import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { toast, Flip } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { setSelectedLanguage } from '@modules/chapter';
import LoadingComponent from '../../../../../app/components/_commons/LoadingComponent';
import api from '@utils/axiosInstance';
import { set } from 'video.js/dist/types/tech/middleware';

function DeleteChapterModal({
    deleteDialogOpen,
    setDeleteDialogOpen,
    languageToDelete,
    setLanguageToDelete,
    availableChapterLanguages,
    setAvailableChapterLanguages,
    currentSelectedLanguage,
    setCurrentSelectedLanguage,
    setShowNoChap
}) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const userToken = useSelector(state => state.organization.userToken);
    const { organization_code } = useSelector(state => state.organization.organizationData);
    const { uuid, lang } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [isLoading, setIsLoading] = useState(false);

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setLanguageToDelete(null);
    };

    const handleDeleteConfirm = async () => {
        if (!languageToDelete) return;

        setIsLoading(true);

        try {
            const response = await api({
                method: 'delete',
                url: '/chapter/delete',
                data: {
                    tk: userToken,
                    uuid: uuid, // 실제 사용 시 비디오 UUID로 대체해야 함
                    ogc: organization_code, // 실제 사용 시 적절한 값으로 대체해야 함
                    lang: languageToDelete.lang
                }
            });
            console.log('sds', response.data)
            if (response.data && response.data.code == 100) {
                // 삭제 성공 처리
                const updatedLanguages = availableChapterLanguages.filter(
                    lang => lang.lang !== languageToDelete.lang
                );
                setAvailableChapterLanguages(updatedLanguages);

                if (updatedLanguages.length > 0) {
                    // 삭제한 언어가 현재 탭의 언어와 같다면 다른 언어로 변경 && 삭제한 언어가 현재 탭의 언어와 다르면 그대로
                    if (languageToDelete.lang === currentSelectedLanguage.lang) {
                        setCurrentSelectedLanguage(updatedLanguages[0]);
                        const pathSegments = location.pathname.split('/');
                        const subtitleIndex = pathSegments.findIndex(segment => segment === 'chapter');
                        if (subtitleIndex !== -1) {
                            const newPath = pathSegments.slice(0, subtitleIndex + 1).join('/') + '/' + updatedLanguages[0].lang;
                            navigate(newPath, { replace: true });
                        }
                    }
                } else {
                    const pathSegments = location.pathname.split('/');
                    const subtitleIndex = pathSegments.findIndex(segment => segment === 'chapter');
                    if (subtitleIndex !== -1) {
                        const newPath = pathSegments.slice(0, subtitleIndex + 1).join('/');
                        navigate(newPath, { replace: true });
                    }
                    setCurrentSelectedLanguage(null);
                    setShowNoChap(true);
                }

                toast.success("챕터를 삭제했습니다.", {
                    position: "top-center",
                    transition: Flip
                });
            } else {
                toast.error("챕터 삭제에 실패했습니다.", {
                    position: "top-center",
                    transition: Flip
                });
            }
        } catch (error) {
            toast.error(t('vod.manage.chapter_tab.chapter_delete_failed') || "챕터 삭제에 실패했습니다.", {
                position: "top-center",
                transition: Flip
            });
        } finally {
            setDeleteDialogOpen(false);
            setIsLoading(false);
            setLanguageToDelete(null);
        }
    };

    return (
        <Dialog
            open={deleteDialogOpen}
            onClose={handleDeleteCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t('vod.manage.chapter_tab.delete_confirmation_title') || '챕터 삭제 확인'}
            </DialogTitle>
            {
                isLoading ?
                    <div className="loading-container">
                        <div className="loading-text">{t('vod.manage.chapter_tab.deleting_chapter') || '챕터 삭제 중 입니다.'}</div>
                    </div>
                    :
                    <>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {currentSelectedLanguage &&
                                    (t('vod.manage.chapter_tab.delete_confirmation_message',
                                        { language: t(`languages.${currentSelectedLanguage.lang}`) }) ||
                                        `${t(`languages.${currentSelectedLanguage.lang}`)} 챕터를 정말 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`)}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDeleteCancel} color="primary">
                                {t('common.cancel') || '취소'}
                            </Button>
                            <Button onClick={handleDeleteConfirm} color="error" autoFocus>
                                {t('common.delete') || '삭제'}
                            </Button>
                        </DialogActions>
                    </>
            }

        </Dialog>
    );
}

export default DeleteChapterModal;